// extracted by mini-css-extract-plugin
module.exports = {"UplaodItem":"upload_UplaodItem__1FcVP","uploadedItem":"upload_uploadedItem__1i62f"};